<template>
<div v-show="showLoader" class="loader"><img src="../../../assets/images/loader.gif" alt=""></div> 
    <main class="main_content">
      <div class="row mb-4 align-items-center">
        <div class="col-md-8">
          <h2 class="page_title">Inventory Detail History</h2>
        </div>
        <div class="col-md-4">
          <div class="top_btns">
              <a @click="back_inventory" class="btn btn-gray me-2">Back</a>
          </div>
        </div>
      </div>
      <div class="card_box">
        <div class="inquiry_detail detail_content">
            <div class="row">
                <div class="col-md-4 contact_half_col">
                    <div class="detail_col">
                        <label>Inquiry ID</label>
                        <p>{{inventory.inq_id}}</p>
                    </div>
                </div>
                <div class="col-md-4 contact_half_col">
                    <div class="detail_col">
                        <label>Customer Name</label>
                        <p>{{inventory.customer_name}}</p>
                    </div>
                </div>
                 <div class="col-md-4 contact_half_col">
                    <div class="detail_col">
                        <label>Quantity</label>
                        <p>{{inventory.quantity}}</p>
                    </div>
                </div>
                <div class="col-md-4 contact_half_col">
                    <div class="detail_col">
                        <label>Stock In Hand</label>
                        <p>{{inventory.remaining_quantity}}</p>
                    </div>
                </div>
                <div class="col-md-4 contact_half_col">
                    <div class="detail_col">
                        <label>Warehouse</label>
                        <p>Location</p>
                    </div>
                </div>
            </div>
            <h5 class="font_700 my-4">Inventory Detail</h5>
            <div class="table_listing">
               
                <table id="inventories" class="table display" style="width:100%">
                    <thead>
                    <tr>
                        <th>Received Date</th>
                        <th>Shipped Date</th>
                        <th>Type</th>
                        <th>Quantity</th>
                    </tr>
                    </thead>
                    
                </table>
            </div>
            <div class="text-end mt-5">
                <button type="button" class="btn btn-secondary ms-2" data-bs-toggle="modal" data-bs-target="#release-inventory">Release Inventory</button>
            </div>
        </div>
      </div>
      <div class="card_box mt-4">
        <h2 class="page_title">Messages</h2>
        <div class="chat_body">
          <Messages :type="type" :token="accessToken" :loadItem="selecteItem" :needSend="false"></Messages>
        </div>
      </div>
      <div class="modal fade" id="release-inventory" data-bs-backdrop="static" tabindex="-1" aria-labelledby="ratingLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="ratingLabel">Release Inventory</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
               
                <div class="modal_content">
                    <div class="form-group">
                        <Form @submit="handleReleaseInventory" :validation-schema="schema">
                          
                            <div class="form-group">
                                 <label class="label">Quantity <span class="required">*</span></label>
                                <Field name="release" v-model="release" type="number" class="form-control"  placeholder="No of Release Inventory" @focusout="checkInventory($event)"  />
                                <ErrorMessage name="release" class="error-feedback" />
                            </div>
                            <div class="form-group">
                            <label class="label">Notes <span class="required">*</span></label>
                            
                            
                            <editor
                                api-key="ib23r73dw4tplnpttr0jwef67tx2w0e9m4x6mhdi4simy6uh"
                                @change="addReleaseInventory"
                                v-model="message"
                                :init="{
                                    menubar: false,
                                    plugins: 'lists link',
                                    toolbar: 'bold italic | bullist'
                                }"
                                />
                                <span class="error-feedback">{{note_required}}</span>
                            </div>
                            
                            <div class="form-group">
                                <button type="submit" :disabled="btnDisabled" class="btn btn-primary btn-block">Release Inventory</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
    </main>
</template>
<script>
import $ from 'jquery';

import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

import Editor from '@tinymce/tinymce-vue';
import Messages from "../../support/Messages.vue";

import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
export default {
  name: "InventoryDetail",
  components: {
    'editor': Editor,
    Form,
    Field,
    ErrorMessage,
    Messages
  },
  data(){ 
    
    const schema = yup.object().shape({
      release: yup
        .number()
        .required("Quantity release is required!")
        .min(1, "Must be at least 1 characters!")     
    });
    return{
        inv_id: null,
        releaseInventoryModal: false,
        API_URL: process.env.VUE_APP_API_URL,
        inventory: {},
        inventory_detail: [],
        chat_userId: null,
        release: null,
        message: null,
        btnDisabled: true,
        schema,
        note_required: null,
        chat_user_type:null,
        created_by:null,
    };
  },
  computed: {
    currentUser() {
        return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  watch: { 
      
    chat_userId () { 

      this.selecteItem = {
        "module_id": this.inv_id,
        "module_name":"inventory",
        "user_id" :  this.chat_userId,
      }
      this.type = this.currentUser.user_type;
      this.accessToken = this.currentUser.accessToken;

    },
    created_by() {
     
      if ( this.chat_user_type != "Admin" ) {
        console.log("not admin");
        this.chat_userId = this.created_by;
      } 
    }

  },
  mounted() {
      this.inv_id=this.$route.params.id;
       this.getChatUser();
       this.geInventoryDetail();
       if (!this.currentUser) {
            this.$router.push('/login');
       }
  },
  methods: {

    logOut() {
        this.$store.dispatch('auth/logout');
        this.$router.push('/login');
    },
    back_inventory() {
      this.$router.push('/inventory');
    },

    checkInventory (e){
      let value = parseInt(e.target.value);
      this.btnDisabled = ( value > this.inventory.quantity ) ? true:false;
    },

   

    
    handleReleaseInventory() {
       
        if(this.message == null || this.message.trim() == '' ){
          this.note_required = "Notes is required";
          return false;
        }
        
        

      
        let module_id = this.inv_id;
        let inquiry_id = this.inventory.inq_id;
        let module_name = "inventory";
      
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

        var formdata = new FormData();
        formdata.append( "module_id", module_id );
        formdata.append( "module_name", module_name );
        formdata.append( "chat_user_id", this.chat_userId );
        formdata.append( "message",  'Inquiry ID:'+ inquiry_id +'<br>Requested Quantity:'+ this.release +' '+ this.message  );

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.API_URL + "customer/request-release-inventory", requestOptions)
        .then(response => response.text())
        .then(result => { 

          var response = JSON.parse(result);
          if(response.status == true){
            $('#release-inventory').hide();
            $('.modal-backdrop').hide();
            window.location.reload();
          }
        })
        .catch(error => console.log('error', error));
    },

     /* Method to get the Received ID for Chart */
    getChatUser () {

      

      let module_id = this.inv_id;
      let module_name = "inventory";
     
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

      var formdata = new FormData();
      formdata.append( "module_id", module_id );
      formdata.append( "module_name", module_name );

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.API_URL + "getChatUserId", requestOptions)
      .then(response => response.text())
      .then(result => { 

        var response = JSON.parse(result);
        console.log(response)
        this.chat_userId = response.data.chat_user_id;
        this.chat_user_type = response.data.chat_user_type;
      
      })
      .catch(error => console.log('error', error));

    },
   
    geInventoryDetail() {
        var store = this.$store;
        var route = this.$router;
        this.showLoader = true; 
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);
        var formdata = new FormData();
        formdata.append("inv_id", this.inv_id);
        formdata.append("api_token", this.currentUser.accessToken);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.API_URL + "customer/inventory-detail/", requestOptions)
          .then(response => response.text())
          .then(result => { 
              var response = JSON.parse(result);
              console.log("responsesss", response)
              
              if(response.message == 'Token not found.'){
                  this.showLoader = false; 
                  store.dispatch('auth/logout');
                  route.push('/login');
              }else{
              
                 this.inventory = response.inv;
                 this.inventory_detail = response.inv_trs;

                 this.created_by = response.inv.created_by;

                 console.log("created_by",this.created_by);
                
                  $('#inventories').DataTable({
                    deferRender: true,
                    sDom: 'rtilfp',
                    aaSorting: [],
                    bFilter: false,
                    data: this.inventory_detail,
                    columns: [
                        { data: "created_at" },
                        { data: "shipment_date" },
                        { data: "status_html" },
                        { data: "released_quantity" },
                    ],
                });
              }
          })
          .catch(error => console.log('error', error));

          this.showLoader = false;        
    },
  },
};
</script>